export const setCategories = (state, categories) => state.categories = categories

export const setFullAccessByCategory = (state, {categoryId, value}) => {
    const categoryIndex = state.categories.findIndex(
        category => category.id === categoryId);

    Object.assign(state.categories[categoryIndex], {
        full_access: value,
    });
}

export const bulkSetFullAccess = (state, isFullAccess) => {
    state.categories.forEach(category => {
        category.full_access = isFullAccess;
    });
}
